export const teamsReducer = (state = [], action) => {
    switch(action.type) {
        case 'TEAMS':
            return [...state, ...action.payload];

        default:
            return state;
    } 
    // return [
    //     {id: 1, name: "Avenel 1", caption: 'Caption 1'},
    //     {id: 2, name: "Avenel 2", caption: 'Caption 1'},
    //     {id: 3, name: "Avenel 3", caption: 'Caption 1'},
    //     {id: 4, name: "Edison 1", caption: 'Caption 1'},
    //     {id: 5, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 6, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 7, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 8, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 9, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 10, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 11, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 12, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 13, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 14, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 15, name: "Edison 2", caption: 'Caption 1'},
    //     {id: 16, name: "Edison 2", caption: 'Caption 1'},        
    // ]
};

// export const selectedTeamReducer = (selectedTeam=null, action) => {
//     if(action.type="TEAM_SELECTED") {
//         return action.payload;
//     }   
//     return selectedTeam;
// };


// WEBPACK FOOTER //
// ./src/reducers/Team.js